export const AddLocaleDateString = (date: Date) => {
  if (date) {
    return date?.toLocaleDateString('pt-BR').split('/').reverse().join('-');
  }
};
